import { CONFIG } from '@/scripts/app-configs/constants'

export default {
  fetchInstitutionDetails: {
    api: {
      url: 'default',
    },
    $$method: 'get',
    $$meta: {
      mock: (_, institutionId ) => `mocks/endpoints/institutions/fetchInstitutionDetails/${institutionId}.json`,
    },
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, institutionId) {
      return `api/v1/institutions/${institutionId}`
    },
  },
  fetchInstitutionClientData: {
    api: {
      url: CONFIG.onboardingApiUrl,
    },
    $$method: 'get',
    $$meta: {
      mock: () => 'mocks/endpoints/institutions/fetchInstitutionClientData.json',
    },
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, uniqueKey) {
      return `${configs.api.url}/v2/clients/${uniqueKey}`
    },
  },
  clinical: {
    fetchTherapiesByInstitutionID: {
      api: {
        url: 'default',
      },
      $$method: 'get',
      $$meta: {
        mock: (_, institutionID ) => `mocks/endpoints/institutions/fetchTherapiesByInstitutionID/${institutionID}.json`,
      },
      $$config: {
        headers: (data) => data.headers.authorization,
      },
      $$makeUrl(configs, institutionID) {
        return `api/v1.1/therapies?institution_id=${institutionID}`
      },
    },
    fetchTherapiesByKitName: {
      api: {
        url: 'default',
      },
      $$method: 'get',
      $$meta: {
        mock: (_, { institutionID } ) => `mocks/endpoints/institutions/fetchTherapiesByInstitutionID/${institutionID}.json`,
      },
      $$config: {
        headers: (data) => data.headers.authorization,
      },
      $$makeUrl(configs, { institutionID, kitName }) {
        const url = 'api/v1.1/therapies'
        const queryParams = new URLSearchParams('')

        queryParams.append('institution_id', institutionID)

        if (kitName) {
          queryParams.append('kit_name', kitName)
        }

        return `${url}?${queryParams}`
      },
    },
    fetchPathologyList: { // TODO Will get dupl. when these task and protocols get merged. Remove ASAP
      api: {
        url: 'default',
      },
      $$method: 'get',
      $$config: {
        headers: (data) => data.headers.authorization,
      },
      $$makeUrl() {
        return 'api/v1.1/pathologies'
      },
    },
  },
}
